<template>
  <div>
    <!--    پاداش تقریبی فعال، APR (سالانه)-->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="state.detailContents.status !== FiltersType.CANCELED"
    >
      <span class="font-Regular-14">{{
        $t(
          "staking.stakingPlans.dialogDetail.planInfo.Estimated_Active_Reward_APR"
        )
      }}</span>
      <span class="font-Bold-18 ltr success--text"
        >≈{{ state.detailContents.activeApy }}%</span
      >
    </div>
    <!--    پاداش به دست آمده تا امروز-->
    <div class="d-flex align-center justify-space-between mb-7">
      <span class="font-Regular-14">{{
        state.detailContents.status === FiltersType.CANCELED
          ? $t("staking.stakingPlans.dialogDetail.planInfo.Reward_Earned")
          : $t(
              "staking.stakingPlans.dialogDetail.planInfo.Reward_Earned_To_Date"
            )
      }}</span>
      <div class="font-Regular-16 ltr success--text">
        <span class="ms-1">{{ state.detailContents.currentReward }}</span>
        <span>{{ headerData.coinUnit }}</span>
      </div>
    </div>
    <!--    میزان مشارکت شما-->
    <div class="d-flex align-center justify-space-between mb-7">
      <span class="font-Regular-14">{{
        $t("staking.stakingPlans.dialogDetail.planInfo.Your_Contribution")
      }}</span>
      <div class="font-Regular-16 ltr">
        <span class="ms-1">{{
          $thousandMask(state.detailContents.stakedAmount)
        }}</span>
        <span>{{ headerData.coinUnit }}</span>
      </div>
    </div>
    <!--    روزهای مانده / روزهای کل طرح-->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="state.detailContents.status !== FiltersType.CANCELED"
    >
      <span class="font-Regular-14">{{
        $t(
          "staking.stakingPlans.dialogDetail.planInfo.Remaining_Days_Total_Days"
        )
      }}</span>
      <span class="font-Regular-16">
        {{
          `${state.detailContents.duration}/${state.detailContents.remainingRegistrationTime}`
        }}
      </span>
    </div>
    <!--    هزینه انصراف از طرح-->
    <template v-if="state.detailContents.cancelable">
      <div
        v-if="state.detailContents.status !== FiltersType.TERMINATED"
        class="d-flex align-center justify-space-between mb-7"
      >
        <div class="d-flex align-center" style="gap: 24px">
          <span class="font-Regular-14">{{
            $t("staking.stakingPlans.dialogDetail.planInfo.Withdrawal_Fee")
          }}</span>
          <div
            v-if="state.detailContents.status === FiltersType.ACTIVE"
            class="d-flex align-center"
            style="gap: 4px;cursor: pointer"
            @click="cancelSubscriptionDialog = true"
          >
            <span class="primary--text">{{ $t("common.Withdrawal") }}</span>
            <!--          <v-icon clr="var(&#45;&#45;v-primary-base)">$infoIcon</v-icon>-->
          </div>
        </div>
        <span class="font-Regular-16 ltr">{{
          +state.detailContents.cancelFee === 0
            ? $t("common.free")
            : state.detailContents.cancelFee + "%"
        }}</span>
      </div>
    </template>
    <!--    هزینه تمدید خودکار-->
    <div
      v-if="state.detailContents.status === FiltersType.ACTIVE"
      class="d-flex align-center justify-space-between mb-7"
    >
      <span class="font-Regular-14">{{
        $t("staking.stakingPlans.dialogDetail.planInfo.Auto_Renewal_Fee")
      }}</span>
      <span class="font-Regular-16 ltr">{{
        +state.detailContents.renewalFee === 0
          ? $t("common.free")
          : state.detailContents.renewalFee + "%"
      }}</span>
    </div>
    <!--  تاریخ پیوستن به طرح  -->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="state.detailContents.status !== FiltersType.ACTIVE"
    >
      <span class="font-Regular-14">
        {{ $t("staking.stakingPlans.dialogDetail.planInfo.Plan_Join_Date") }}
      </span>
      <div>
        <span class="font-Regular-16 ltr">
          {{ state.detailContents.subscriptionTime | formatDate }}
        </span>
      </div>
    </div>
    <!--  تاریخ انصراف  -->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="state.detailContents.status === FiltersType.CANCELED"
    >
      <span class="font-Regular-14">
        {{ $t("staking.stakingPlans.dialogDetail.planInfo.Withdrawal_Date") }}
      </span>
      <div>
        <span class="font-Regular-16 ltr">
          {{ state.detailContents.cancelTime | formatDate }}
        </span>
      </div>
    </div>
    <!--    مدت زمان آزاد سازی دارایی-->
    <div class="d-flex align-center justify-space-between mb-7">
      <span class="font-Regular-14">{{
        $t(
          "staking.stakingPlans.dialogDetail.planInfo.Waiting_Period_For_Asset_Release"
        )
      }}</span>
      <div>
        <span class="font-Regular-16">
          {{
            $t("staking.stakingDetailPage.oneDayAfterPlanCompletion", {
              day: state.detailContents.releaseDuration
            })
          }}
        </span>
      </div>
    </div>
    <!--    مدت زمان آزاد سازی دارایی پس از انصراف-->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="
        state.detailContents.status === FiltersType.ACTIVE &&
          state.detailContents.cancelable
      "
    >
      <span class="font-Regular-14">
        {{
          $t(
            "staking.stakingPlans.dialogDetail.planInfo.Waiting_Period_For_Asset_Release_After_Withdrawal"
          )
        }}
      </span>
      <div>
        <span class="font-Regular-16 ltr">
          {{
            $t("staking.stakingDetailPage.oneDayAfterWithdrawal", {
              day: state.detailContents.cancelReleaseDuration
            })
          }}
        </span>
      </div>
    </div>
    <!--    تاریخ اتمام تمدید-->
    <div
      class="d-flex align-center justify-space-between mb-7"
      v-if="
        !!state.detailContents.renewalEndDate &&
          state.detailContents.status === FiltersType.ACTIVE
      "
    >
      <div class="d-flex align-center" style="gap: 16px">
        <span class="font-Medium-18">{{
          $t("staking.stakingPlans.dialogDetail.planInfo.Renewal_End_Date")
        }}</span>
        <!--        <v-icon clr="var(&#45;&#45;v-gray3-base)">$infoIcon</v-icon>-->
      </div>
      <span class="font-Medium-14">
        {{ state.detailContents.renewalEndDate | formatDate }}
      </span>
    </div>

    <!--    cancel modal-->
    <v-dialog v-model="cancelSubscriptionDialog" width="500">
      <v-card class="text-center gray13">
        <v-card-text>
          <h2 class="py-4">
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planInfo.Withdraw_From_Plan"
              )
            }}
          </h2>
          <p>
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planInfo.Confirm_Withdrawal_Message"
              )
            }}
          </p>
          <v-btn
            class="primary"
            :loading="isLoading"
            @click="cancelSubscription(state.detailContents.id)"
          >
            {{
              $t(
                "staking.stakingPlans.dialogDetail.planInfo.Withdraw_From_Plan"
              )
            }}</v-btn
          >
          <v-btn
            class="primary ms-2"
            @click="cancelSubscriptionDialog = false"
            >{{ $t("common.Return") }}</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import StakingService from "@/services/modules/market/staking";
import { FiltersType } from "@/store/types";
export default {
  inject: ["state"],
  mixins: [$exponent, $thousandMask],
  props: {
    data: {
      type: Array
    },
    headerData: Object
  },
  data() {
    return {
      cancelSubscriptionDialog: false,
      isLoading: false
    };
  },
  methods: {
    cancelSubscription(id) {
      this.isLoading = true;
      StakingService.cancelSubscription(id)
        .then(res => {
          if (res.data.code === 0) {
            window.location.reload();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  computed: {
    FiltersType() {
      return FiltersType;
    }
  }
};
</script>

<style lang="scss" scoped></style>
